import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../../providers/withRouter";
import { useNavigate } from "react-router-dom";
import { Box, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import {
  LaeButton,
  PropertieSelector,
} from "../../../../components";
import { createInstalacion, getServiciosFincas, getProductosKae } from "../../../../services";
import { toast } from "react-toastify";
import { formatoFechas } from "../../../../functions/funciones";
import Swal from "sweetalert2";

const NuevaInstalacion = (props) => {
  const { t } = useTranslation(['common', 'properties']);
  const navigate = useNavigate();
  const [propertieDrawer, setPropertieDrawer] = useState(false);
  const [fecha, setFecha] = useState(formatoFechas(new Date()));

  const [propertieInfo, setPropertieInfo] = useState({});
  const [serviceInfo, setServiceInfo] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [senalesObligatorias, setSenalesObligatorias] = useState([]);
  const [senalesMarcadas, setSenalesMarcadas] = useState([]);
  useEffect(() => {
    fetchData();
  }, [])
  const openPropertieDrawer = () => setPropertieDrawer(true);
  const getFecha = (e) => {
    setFecha(e.target.value);
  };

  const closePropertieDrawer = (row) => {
    if (row.data) {
      const {
        finca: { workSales: centrosTrabajo },
        aaff: { id: aaff_id, commer_id: commer_id, tech_id: tech_id },
        id_main_property,
        community: community_name,
        isWorkcenter,
        id,
      } = row.data;
      // console.log(row.data);
      setPropertieInfo({
        prop_id: id_main_property,
        workcenter_id: isWorkcenter ? id : null,
        name: community_name,
        aaff_id: aaff_id,
        commer_id: commer_id,
        centrosTrabajo: centrosTrabajo,
      });
    }

    setPropertieDrawer(false);
  };

  const fetchData = async () => {
    const servicios = await getServiciosFincas();
    const serviciosKae = servicios?.filter(s => s.nombre.includes("KAE")) ?? [];
    setServiceInfo(serviciosKae)
    // Solo hay un servicio KAE: se deja elegido para no obligar a seleccionarlo
    if (serviciosKae.length === 1) setSelectedService(serviciosKae[0].id);
    // Solo las señales marcadas como obligatorias en el catalogo pueden exigirse
    const productos = await getProductosKae();
    const items = Array.isArray(productos) ? productos : (productos?.data ?? []);
    setSenalesObligatorias(items.filter(p => p.obligatorio));
  }

  const alternarSenal = (id) => {
    setSenalesMarcadas((previas) =>
      previas.includes(id) ? previas.filter(s => s !== id) : [...previas, id]
    );
  };

  const saveSale = async () => {
    let toastInfo = toast.info(t('services.messages.creatingSale'), { autoClose: false });
    let data = {};
    if (propertieInfo.prop_id) {
      data = {
        prop_id: propertieInfo.prop_id,
        workcenter_id: propertieInfo.workcenter_id,
        commer_id: propertieInfo.commer_id,
        servp_id: selectedService,
        invoiceDate: fecha,
        senalesObligatorias: senalesMarcadas,
      };
    }
    let itemsErr = {};

    try {
      let errores = false;

      if (new Date(data.invoiceDate).getTime() > new Date().getTime()) {
        toast.update(toastInfo, {
          render: t('services.messages.futureDateError'),
          type: toast.TYPE.ERROR,
          autoClose: true,
        });
        return;
      }
      const response = await createInstalacion(data);
console.log(response)
      if (response.status === 200 && errores === false) {
        toast.update(toastInfo, {
          render: response.msg,
          type: toast.TYPE.SUCCESS,
          autoClose: true,
        });
        setTimeout(() => {
          navigate("/instalaciones");
        }, 2000);
      } else {
        if (response.status === 400) {
          if (response.msg) {
            itemsErr = response.msg;
          } else {
            itemsErr = response.data.error;
          }
          toast.dismiss(toastInfo);
          errores = true;
        } else {
          itemsErr = response.error;
          toast.dismiss(toastInfo);
          errores = true;
        }

        const html = `
        <div style="display: flex;">
            <div style="flex: 1;">
                <ul style="font-size:13px; margin-top:10px; text-align:left;">
                    ${`<li style="margin:5px 0;">${itemsErr}</li>`}
                </ul>
            </div>
        </div>
    `;
        // console.log(itemsErr);
        Swal.fire({
          title: t('services.messages.createError'),
          html: html,
          confirmButtonText: t('actions.close'),
          icon: "error",
        });
      }
    } catch (err) {
      console.log(err);
      toast.error(t('services.messages.emptyFieldsError'));
      toast.dismiss(toastInfo);
    }
  };

  return (
    <>
      <PropertieSelector
        open={propertieDrawer}
        onClose={closePropertieDrawer}
      />
      <div
        className="pageHeader"
        style={{ backgroundColor: "#f6f7fb", alignContent: "center" }}
      >
        <Typography variant="h4" color="#212529" fontWeight={"bold"}>
          {t('installations.createNew')}
        </Typography>
      </div>
      <Box
        className="pageContent"
        sx={{
          maxWidth: 900,
          margin: "0 auto",
          p: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            mb: 10,
            maxWidth: 700,
            margin: "0 auto",
          }}
        >
          <Typography variant="h4" sx={{ mb: 2 }}>
            {t('installations.saleDetails')}
          </Typography>
          <Box display={"flex"} flexDirection={"row"} flex={1} gap={2}>
            <TextField
              id="propertie-selector"
              label={propertieInfo.workcenter_id ? t('properties:workCenter.title') : t('properties:titleSingular')}
              placeholder={t('properties:titleSingular')}
              variant="outlined"
              InputProps={{
                readOnly: true,
              }}
              value={propertieInfo.name ?? ""}
              onClick={openPropertieDrawer}
              fullWidth
            />
          </Box>
          <Box display={"flex"} flexDirection={"row"} flex={1} gap={2}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel id="service-label">{t('services.serviceToHire')}</InputLabel>
              <Select
                labelId="service-label"
                id="service-select"
                label={t('services.serviceToHire')}
                name="servicio"
                variant="outlined"
                value={selectedService}
                onChange={(e) => setSelectedService(e.target.value)}
                fullWidth
              >
                <MenuItem value="" style={{ height: 40 }}></MenuItem>
                {serviceInfo?.map((e, i) => {
                  return (
                    <MenuItem key={i} value={e.id}>
                      {e.nombre}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Box>
          <Box display={"flex"} flexDirection={"row"} flex={1} gap={2}>
            <TextField
              type="date"
              label={t('installations.columns.invoiceDate')}
              variant="outlined"
              name="fecha"
              value={formatoFechas(new Date(fecha))}
              InputLabelProps={{ shrink: true }}
              onChange={getFecha}
              fullWidth
            />
          </Box>
          {senalesObligatorias.length > 0 && (
            <Box>
              <Typography sx={{ fontWeight: 600, mb: 1 }}>
                {t('installations.mandatorySignage')}
              </Typography>
              <Typography sx={{ fontSize: '0.85rem', color: '#666', mb: 1 }}>
                {t('installations.mandatorySignageHint')}
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, maxHeight: 220, overflowY: 'auto', border: '1px solid #e0e0e0', borderRadius: 1, p: 1.5 }}>
                {senalesObligatorias.map((senal) => (
                  <Box key={senal.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <input
                      type="checkbox"
                      id={`senal-${senal.id}`}
                      checked={senalesMarcadas.includes(senal.id)}
                      onChange={() => alternarSenal(senal.id)}
                      style={{ width: 'auto', margin: 0 }}
                    />
                    <label htmlFor={`senal-${senal.id}`} style={{ margin: 0, cursor: 'pointer' }}>
                      {senal.sku} - {senal.nombre}
                    </label>
                  </Box>
                ))}
              </Box>
            </Box>
          )}
          <LaeButton
            onClick={() => saveSale()}
            sx={{ width: 700, height: 40, alignSelf: "center" }}
          >
            <Typography>{t('actions.save')}</Typography>
          </LaeButton>
        </Box>
      </Box>
    </>
  );
};

export default withRouter(NuevaInstalacion);
